<template>
  <div class="gs-aff-panel">
    <header class="gs-aff-panel__head">
      <div>
        <h3>JV affiliate information page</h3>
        <p>Link to the page with launch details, dates, prizes, and swipe copy for your JV partners. Affiliates see it in their promo tools.</p>
      </div>
    </header>

    <div class="gs-aff-settings gs-aff-settings--padded">
      <div class="gs-aff-field">
        <span class="gs-aff-field__label">{{ $t('frontend_product_step9_jv_affiliates') }}</span>
        <text-input
          v-model="localModel.jv_page"
          :validator="validation.localModel.jv_page"
          :attribute="$t('frontend_product_step9_jv_affiliates')"
          value="localModel.jv_page"
          placeholder="https://"
        />
        <span class="gs-aff-field__hint">Optional. Use a full URL, including https://.</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      required: true
    },
    validation: {
      required: true
    }
  },
  watch: {
    localModel: {
      handler() {
        this.$emit('update-model', this.localModel);
      },
      deep: true
    }
  },
  data() {
    return {
      localModel: this.model,
    };
  },
};
</script>
